var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20",
    "data-name": "Rounded Rectangle 20",
    className: "cls-1",
    d: "M9.5,18.3H9.527a5.52,5.52,0,0,1,5.52,5.52v2.335a5.52,5.52,0,0,1-5.52,5.52H9.5a5.52,5.52,0,0,1-5.52-5.52V23.817A5.52,5.52,0,0,1,9.5,18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20_copy",
    "data-name": "Rounded Rectangle 20 copy",
    className: "cls-1",
    d: "M25.516,17.953a5.5,5.5,0,0,1,5.5,5.5v3.063a5.5,5.5,0,0,1-11,0V23.453A5.5,5.5,0,0,1,25.516,17.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20_copy_2",
    "data-name": "Rounded Rectangle 20 copy 2",
    className: "cls-1",
    d: "M41.516,17.859a5.5,5.5,0,0,1,5.5,5.5v3.25a5.5,5.5,0,0,1-11,0v-3.25A5.5,5.5,0,0,1,41.516,17.859Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_20_copy_3",
    "data-name": "Rounded Rectangle 20 copy 3",
    className: "cls-2",
    d: "M42.016,18.484a5.5,5.5,0,0,1,5.5,5.5v2a5.5,5.5,0,0,1-11,0v-2A5.5,5.5,0,0,1,42.016,18.484Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.efc81a1b5607632e19bd57e208126e3c.svg";
export { ForwardRef as ReactComponent };